import {Component, OnDestroy, OnInit} from "@angular/core";
import {FamilleFacturationService} from "../../../../core/services/entities/famille-facturation.service";
import {SiteDTO} from "../../../../core/dtos/site-dto";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {Subscription} from "rxjs";
import {FormControl, FormGroup} from "@angular/forms";
import {MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {FamilleFacturationDto} from "../../../../core/dtos/facturation/clients/famille-facturation/famille-facturation-dto";
import {UtilsService} from "../../../../core/utils/utils.service";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
  selector: 'yo-famille-facturation-edition',
  templateUrl: './famille-facturation-edition.component.html',
  styleUrls: ['./famille-facturation-edition.component.scss'],
  standalone: false
})
export class FamilleFacturationEditionComponent implements OnInit, OnDestroy {

  subOpenDialog: Subscription
  subSaveFamilleFactu: Subscription

  form: FormGroup = new FormGroup({});

  dialogTitle: string = 'Modification d\'une famille de facturation';

  sitePlaceholder: string = 'Selectionner le site...';
  displayDialog = false;
  idSelectedSite: number;

  familleFacturation: FamilleFacturationDto;

  constructor(public familleFacturationSvc: FamilleFacturationService,
              public auth2Svc: Auth2Service,
              public toastSvc: ToastService,
              public utilsSvc: UtilsService) {
  }

  ngOnInit(): void {
    this.initForm();
    this.openDialogEditionSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
    this.utilsSvc.unsubscribe(this.subSaveFamilleFactu);
  }

  findAllLocalSites = (): SiteDTO[] => {
    return this.auth2Svc.utilisateur.siteListLocaux;
  }

  canModify = () => {
    return this.familleFacturationSvc.canModify(this.familleFacturation);
  }

  openDialogEditionSubscription = (): void => {
    this.subOpenDialog = this.familleFacturationSvc.openDialogEdition$
      .subscribe((element: FamilleFacturationDto) => {
        this.displayDialog = true;
        if (!element) {
          this.familleFacturation = new FamilleFacturationDto();
          this.familleFacturation.id = null;
          this.dialogTitle = 'Création d\'une famille de facturation';
        } else {
          this.familleFacturation = element;
          this.dialogTitle = 'Modification d\'une famille de facturation';
        }
        this.initForm();
      });
  };

  closeDialog = (): void => {
    this.displayDialog = false;
  };

  onChangeSite = (data: any): void => {
    this.idSelectedSite = data;
  }

  save = (): void => {
    if (this.form.valid) {
      const familleFacturation: FamilleFacturationDto = {...this.familleFacturation};
      familleFacturation.site = {id: this.idSelectedSite} as SiteDTO;
      familleFacturation.libelle = this.form.controls['libelle'].value;
      familleFacturation.code = this.form.controls['code'].value;
      this.subSaveFamilleFactu = this.familleFacturationSvc.save(familleFacturation)
        .subscribe(response => {
          if (response && response.one) {
            const isUpdate = familleFacturation.id !== null && familleFacturation.id !== undefined && familleFacturation.id !== 0;
            this.familleFacturationSvc.announceElementFacturableSaved(response.one, isUpdate);
            this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Sauvegarde de l'élément facturable réalisée avec succès`);
            this.closeDialog();
          }
        });
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
    }
  };

  initForm = (): void => {
    this.sitePlaceholder = !this.canModify() ? this.familleFacturation?.site?.libelle : 'Sélectionner le site...';
    this.idSelectedSite = this.familleFacturation?.site?.id;
    this.form = new FormGroup({
      libelle: new FormControl(this.familleFacturation?.libelle),
      code: new FormControl(this.familleFacturation?.code),
    });
  };

  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
